/* Box Juntada — lógica de la PDP */
(function () {
  'use strict';

  // ── Ocultar header/announcement/footer nativos del theme ──
  function hideNativeChrome() {
    var page = document.querySelector('.box-juntada-page');
    if (!page) return;
    var node = page;
    while (node.parentElement && node.parentElement !== document.body) { node = node.parentElement; }
    Array.prototype.forEach.call(document.body.children, function (child) {
      if (child === node) return;
      var tag = child.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return;
      var cs = window.getComputedStyle(child);
      if (cs.position === 'fixed' && parseInt(cs.zIndex, 10) > 100) return; // preservar WhatsApp, etc.
      child.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideNativeChrome);
  else hideNativeChrome();

  // ── Precio desde Shopify (window.BOX_PRICE / BOX_COMPARE en pesos) ──
  var UNIT = (typeof window.BOX_PRICE === 'number' && window.BOX_PRICE > 0) ? window.BOX_PRICE : 79000;
  var COMPARE = (typeof window.BOX_COMPARE === 'number') ? window.BOX_COMPARE : 0;
  function fmt(n) { return '$' + Math.round(n).toLocaleString('es-AR'); }
  var hasCompare = COMPARE && COMPARE > UNIT;
  var off = hasCompare ? Math.round((COMPARE - UNIT) / COMPARE * 100) : 0;
  document.querySelectorAll('.box-juntada-page [data-role="price"]').forEach(function (el) { el.textContent = fmt(UNIT); });
  document.querySelectorAll('.box-juntada-page [data-role="compare"]').forEach(function (el) { el.style.display = hasCompare ? '' : 'none'; if (hasCompare) el.textContent = fmt(COMPARE); });
  document.querySelectorAll('.box-juntada-page [data-role="badge"]').forEach(function (el) { el.style.display = hasCompare ? '' : 'none'; if (hasCompare) el.textContent = off + '% OFF'; });

  // ── Banner sticky que crece al scroll ──
  (function () {
    var b = document.getElementById('jbar'); if (!b) return; var t = false;
    function u() {
      var y = window.scrollY, h = document.documentElement.scrollHeight - window.innerHeight, p = h > 0 ? y / h : 0;
      b.classList.remove('is-grown', 'is-mega');
      if (p >= 0.75) b.classList.add('is-mega'); else if (y > 200) b.classList.add('is-grown'); t = false;
    }
    window.addEventListener('scroll', function () { if (!t) { window.requestAnimationFrame(u); t = true; } }, { passive: true }); u();
  })();

  // ── FAQ accordion ──
  document.querySelectorAll('.box-juntada-page .faq-item').forEach(function (item) {
    var row = item.querySelector('.faq-q-row'); if (!row) return;
    row.addEventListener('click', function () { item.classList.toggle('open'); });
  });

  // ── Qty + breakdown (todo deriva de UNIT = product.price) ──
  var qty = 1, MIN = 1, MAX = 5;
  function updatePrices() {
    var total = UNIT * qty;
    var setText = function (id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; };
    setText('qty-display', qty);
    setText('bd-box-label', 'Box Juntada × ' + qty);
    setText('bd-box-val', fmt(total));
    setText('bd-total', fmt(total));
    setText('btn-total', fmt(total));
    var minus = document.getElementById('qty-minus'), plus = document.getElementById('qty-plus');
    if (minus) minus.disabled = qty <= MIN;
    if (plus) plus.disabled = qty >= MAX;
  }
  window.changeQty = function (d) { qty = Math.max(MIN, Math.min(MAX, qty + d)); updatePrices(); };

  // ── Shopify Cart API: agregar al carrito + redirect a /checkout ──
  window.handleBuyBox = async function () {
    var variantId = window.BOX_VARIANT_ID;
    if (!variantId) { console.error('Box Juntada: variant ID no definido'); return; }
    var btns = document.querySelectorAll('.box-juntada-page .fc-btn');
    btns.forEach(function (b) { b.disabled = true; });
    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      });
      if (response.ok) { window.location.href = '/checkout'; }
      else { console.error('Box Juntada: error al agregar al carrito', await response.text()); btns.forEach(function (b) { b.disabled = false; }); }
    } catch (err) { console.error('Box Juntada: error de red', err); btns.forEach(function (b) { b.disabled = false; }); }
  };

  updatePrices();
})();


/* Carrusel del hero (flechas/dots + autoplay) */
(function () {
  var cat = document.querySelector('.box-juntada-page .hero-right .cat'); if (!cat) return;
  var sl = cat.querySelectorAll('.cat-slide'), dt = cat.querySelectorAll('.cat-dot');
  if (sl.length < 2) return;
  var i = 0, timer = null;
  function go(n){ sl[i].classList.remove('is-active'); if(dt[i]) dt[i].classList.remove('is-active'); i=(n+sl.length)%sl.length; sl[i].classList.add('is-active'); if(dt[i]) dt[i].classList.add('is-active'); }
  function play(){ timer=setInterval(function(){ go(i+1); }, 3200); }
  function reset(){ clearInterval(timer); play(); }
  var next=cat.querySelector('.cat-next'), prev=cat.querySelector('.cat-prev');
  if(next) next.addEventListener('click', function(){ go(i+1); reset(); });
  if(prev) prev.addEventListener('click', function(){ go(i-1); reset(); });
  dt.forEach(function(d,idx){ d.addEventListener('click', function(){ go(idx); reset(); }); });
  play();
})();
